(function() {
  const a11yHelpers = {
    detectSlickVisibleEls: function(selector) {
      const slickSlideEls = [...document.querySelectorAll(`${selector} .slick-slide`)];
      const callback = (entries) => {
        // SetTimeout is required because slick slider is overwriting the changes below unless a delay is used.
        setTimeout(() => {
          entries.forEach((entry) => {
            const target = entry.target;
            if (entry.isIntersecting) {
              target.setAttribute('tabindex', '0');
              target.setAttribute('aria-hidden', 'false');
              this.setAnchorTabIndex(target, true);
            } else {
              target.setAttribute('tabindex', '-1');
              target.setAttribute('aria-hidden', 'true');
              this.setAnchorTabIndex(target, false);
            }
          });
        }, 500);
      };

      const options = {
        root: null,
        rootMargin: "0px",
        threshold: [0.1, 0.9],
      };

      let observer = new IntersectionObserver(callback, options);
      if (slickSlideEls) {
        this.setSlickSlideRole(slickSlideEls);
        slickSlideEls.forEach((el) => observer.observe(el));
      }
    },
    setAnchorTabIndex: function(el, show) {
      const anchorEls = el.querySelectorAll('a');
      const buttonEls = el.querySelectorAll('button');
      const wrapEls = el.querySelectorAll('.product-card__wrap');
      const targetEls = [...anchorEls, ...buttonEls, ...wrapEls];

      if (targetEls.length && show)  {
        targetEls.forEach((el) => {
          el.setAttribute("tabindex", "0");
          el.setAttribute("aria-hidden", false);
        });
      } else {
        targetEls.forEach((el) => {
          el.setAttribute("tabindex", "-1");
          el.setAttribute("aria-hidden", true);
        });
      }
    },
    setSlickSlideRole: function(slickEls) {
      if (slickEls) {
        slickEls.forEach((el) => {
          el.setAttribute('role', 'group');
          el.setAttribute('aria-roledescription', 'slide');
        });
      }
    },
  };

  window.a11yHelpers = a11yHelpers;

  document.addEventListener('DOMContentLoaded', () => {
    window.a11yHelpers.detectSlickVisibleEls('.feature-carousel__container');
  });
})();
